import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    q: '¿Necesito experiencia previa en yoga?',
    a: '¡Para nada! El kit está diseñado específicamente para principiantes. Las instrucciones son súper claras, visuales y fáciles de seguir tanto para los niños como para los padres.'
  }, {
    q: '¿Sirve para cualquier edad?',
    a: 'El material está adaptado pedagógicamente para niños de 3 a 12 años. Las rutinas y juegos se pueden ajustar fácilmente según la etapa de desarrollo de tu hijo.'
  }, {
    q: '¿Cuánto duran las rutinas?',
    a: 'Hay opciones para todos los momentos. Desde rutinas exprés de 5 minutos para días ocupados, hasta sesiones más completas de 20 minutos para el fin de semana o antes de dormir.'
  }, {
    q: '¿Es digital o me envían algo físico?',
    a: 'Es un producto 100% digital. Esto te permite acceder inmediatamente después de la compra, descargarlo en todos tus dispositivos e imprimir los materiales (como las cartas) las veces que quieras.'
  }, {
    q: '¿Cómo accedo después de comprar?',
    a: 'Al instante de confirmar tu pago, recibirás un correo electrónico con un enlace único y seguro para descargar todos los tomos y los bonus directamente a tu celular, tablet o computadora.'
  }];
  return <section className="py-20 bg-white" data-id="element-77">
      <div className="container mx-auto px-5 sm:px-8 lg:px-12" data-id="element-78">
        <div className="text-center max-w-3xl mx-auto mb-12" data-id="element-79">
          <h2 className="text-3xl md:text-4xl font-display font-bold text-gray-900 mb-4" data-id="element-80">
            Preguntas Frecuentes
          </h2>
        </div>

        <div className="max-w-3xl mx-auto space-y-4" data-id="element-81">
          {faqs.map((faq, index) => <div key={index} className="border border-gray-200 rounded-2xl overflow-hidden bg-white hover:border-pastel-lavender transition-colors" data-id="element-82">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 text-left flex items-center justify-between focus:outline-none" data-id="element-83">
                <span className="font-bold text-gray-800 pr-4" data-id="element-84">{faq.q}</span>
                <motion.div animate={{
              rotate: openIndex === index ? 180 : 0
            }} transition={{
              duration: 0.3
            }} className="text-pastel-lavender-dark shrink-0" data-id="element-85">
                  <ChevronDown size={20} data-id="element-86" />
                </motion.div>
              </button>

              <AnimatePresence data-id="element-87">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-88">
                    <div className="px-6 pb-5 text-gray-600 border-t border-gray-100 pt-4" data-id="element-89">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}